module.exports = __webpack_public_path__ + "img/step_4.bd95f1fa.svg";